import { useTheme } from 'styled-components';
import { IconButton, Pill } from '@workramp/ui';
import { StyledFilterButton } from './FilterButton.styles';

export type FilterButtonProps = {
  label: string;
  filterCount: number;
  onOpen: () => void;
  onReset: () => void;
};

export const FilterButton = ({ label, filterCount, onOpen, onReset }: FilterButtonProps) => {
  const { spacing } = useTheme();

  return (
    <StyledFilterButton
      data-testid="button-filter"
      onPress={onOpen}
      color="secondary"
      variant="outline"
      aria-label={label}
      $paddingRight={filterCount ? 0 : spacing[3]}
      trailingIcon={
        filterCount > 0 ? (
          <>
            <Pill variant="primary-solid">{filterCount}</Pill>
            <IconButton
              iconName="x:regular"
              variant="text-inline"
              color="secondary"
              label="clear filter"
              data-testid="button-clear-filter"
              onPress={onReset}
            />
          </>
        ) : null
      }
    >
      {label}
    </StyledFilterButton>
  );
};
